import React from "react";
import useCallService from "hooks/CallService";
import {UserForm, RatingForm, SimpleCallForm} from "components/UI";
import {CardLayout} from "hoc";
import classes from './SipView.module.css';
import {useTranslation} from 'react-i18next';

const SipView = props => {
    const {t} = useTranslation();
    const {
        link_code,
        follow_log_id,
        require_user_data,
        background_exist,
        enable_call_rating,
        redirect_address,
    } = props.linkData;
    const {
        view,
        ratingForm,
        mute,
        muted,
        call,
        hangUp,
        sendDtmf,
        contactHandler,
        commentHandler,
        changeRating,
        calling,
        answer,
        buildRatingForm,
        buildUserForm,
        paramsToExtraHeaders,
        yaClientId
    } = useCallService(props);

    const handleUserForm = (evt) => {
        evt.preventDefault();
        buildUserForm();
    };
    const handleRatingForm = (evt) => {
        evt.preventDefault();
        buildRatingForm();
    };
    const muteHandler = () => {
        mute();
    };
    const hangUpHandler = () => {
        hangUp();
    };
    const sendDtmfHandler = (number) => {
        sendDtmf(number);
    };
    const callSimpleHandler = () => {
        call(link_code, {
            extraHeaders: [
                `X-client-type: 3b27fc8bfd3f6839314f17e79e3bda1c`,
                `X-Follow-Log-Id: ${follow_log_id}`,
                `X-Session-Id: ${props.statistic.get('session_id')}`,
                `X-Ya-Client-Id: ${yaClientId()}`,
                ...paramsToExtraHeaders()
            ]
        }, props.statistic);
    };
    const makeRedirect = () => {
        const query = Object.fromEntries(
            window.location.search.slice(1).split('&').map(param => param.split('='))
        );

        const redirectAddress = query.redirect_address || redirect_address;
        const urlPattern = new RegExp(/(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/);

        if (redirectAddress && urlPattern.test(redirectAddress)) {
            setTimeout(() => {
                window.location.href = redirectAddress;
            }, 1500);
        }
    }
    return (
        <div className={background_exist ? classes.sipView : classes.sipViewDefault}
             style={{
                 backgroundImage: background_exist ? `url("${process.env.REACT_APP_API_URL}public/img/callme/${background_exist}")` : `url("/images/default.jpg")`,
                 backgroundSize: `cover`,
                 backgroundPosition: 'center'
             }}>
            {view === 'first' &&
                <>
                    {!(!!require_user_data) &&
                        <CardLayout {...props.linkData} image={'call-me'}>
                            <SimpleCallForm
                                callSimpleHandler={callSimpleHandler}
                                muteHandler={muteHandler}
                                hangUpHandler={hangUpHandler}
                                sendDtmfHandler={sendDtmfHandler}
                                calling={calling}
                                answer={answer}
                                muted={muted}
                            />
                        </CardLayout>
                    }
                    {(!!require_user_data) &&
                        <>
                            {!calling &&
                                <CardLayout {...props.linkData} image={'call-me'}>
                                    <UserForm
                                        background_exist={background_exist}
                                        onSubmitForm={handleUserForm}
                                        contactHandler={contactHandler}
                                    />
                                </CardLayout>
                            }
                            {calling &&
                                <CardLayout {...props.linkData}>
                                    <SimpleCallForm
                                        muteHandler={muteHandler}
                                        hangUpHandler={hangUpHandler}
                                        sendDtmfHandler={sendDtmfHandler}
                                        calling={calling}
                                        answer={answer}
                                        muted={muted}
                                    />
                                </CardLayout>
                            }
                        </>
                    }
                </>
            }
            {view === 'second' &&
                <CardLayout {...props.linkData} image={'comment'}>
                    <RatingForm
                        background_exist={background_exist}
                        onSubmitForm={handleRatingForm}
                        call_rating={ratingForm.call_rating}
                        changeRating={changeRating}
                        commentHandler={commentHandler}
                        user_comment={ratingForm.user_comment}
                    />
                </CardLayout>
            }
            {view === 'end' &&
                <CardLayout {...props.linkData}>
                    {enable_call_rating ?
                        <b style={{'color': background_exist && 'white'}}>{t('thanksForReview')}</b> :
                        <b style={{'color': background_exist && 'white'}}>{t('thanksForCall')}</b>
                    }
                    <span style={{display: 'none'}}>{makeRedirect()}</span>
                </CardLayout>
            }
        </div>
    );
};
export default SipView
